/** Persisted trigger when present; otherwise heuristic from appId (pre-schema-deploy / legacy missions). */
export function effectiveMissionTrigger(m) {
    const persistedType = m.triggerType?.trim().toUpperCase();
    if (persistedType) {
        return {
            triggerType: persistedType,
            triggeredBy: m.triggeredBy?.trim() || null,
        };
    }
    const app = m.appId?.trim() || "currents";
    if (app === "currents") {
        return { triggerType: "USER", triggeredBy: m.triggeredBy?.trim() || null };
    }
    return { triggerType: "APP", triggeredBy: app };
}
